(function() {
    'use strict';

    angular
        .module('app.vacacionesDetalle')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/vacaciones-detalle',
                config: {
                    templateUrl: 'app/vacacionesDetalle/vacacionesDetalle.html',
                    controller: 'VacacionesDetalle',
                    controllerAs: 'vm',
                    title: 'VacacionesDetalle'
                }
            }
        ];
    }
})();
